import React from "react";

interface ExtraLaborAndMaterialData {
  benchmark: string; actualELM: string; goal: string; percentOfRevenue: string;
  bonusPercentEarned: string; bonusValue: string; score: string;
}
interface ExtraLaborAndMaterialSubFormProps {
  data: ExtraLaborAndMaterialData; isEditable: boolean; percentOfTotalAchievementScore?: number;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>, options?: { type?: 'number' | 'decimal' | 'text'; maxLength?: number; minLength?: number; max?: number; min?: number }) => void;
}

const ExtraLaborAndMaterialSubForm: React.FC<ExtraLaborAndMaterialSubFormProps> = ({ data, isEditable, percentOfTotalAchievementScore, onInputChange }) => (
  <div className="sf-section">
    <h3 className="sf-title">Extra Labor and Material ({percentOfTotalAchievementScore}% of total achievement score)</h3>
    <p className="sf-subtitle">This will be evaluated from monthly financial reports.</p>
    <div className="grid grid-cols-2 gap-6">
      <div className="space-y-2">
        <label className="sf-label">This quarter the benchmark was:</label>
        <input type="text" inputMode="decimal" maxLength={4} minLength={1}
          name="operationalEfficiency.extraLaborAndMaterial.benchmark" value={data.benchmark}
          onFocus={e => e.target.select()} disabled={!isEditable}
          onChange={e => {
            const value = e.target.value;
            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
              const numValue = parseFloat(value);
              if (value !== '' && !isNaN(numValue) && (numValue < 0.7 || numValue > 1.2)) return;
              onInputChange(e, { type: "decimal", maxLength: 4 });
            }
          }}
          onBlur={e => {
            const value = e.target.value.trim();
            if (!value || value === '.' || parseFloat(value) === 0) { e.target.value = ''; onInputChange(e, { type: "decimal", maxLength: 4 }); return; }
            const num = parseFloat(value);
            if (!isNaN(num)) {
              if (num > 0 && num < 0.7) { e.target.value = '0.7'; onInputChange(e, { type: "decimal", maxLength: 4 }); }
              else if (num > 1.2) { e.target.value = '1.2'; onInputChange(e, { type: "decimal", maxLength: 4 }); }
            }
          }}
          placeholder="Enter value (0.7 - 1.2) for 70% - 120% of Benchmark"
          className="sf-input mt-1 block w-full px-3 py-2 text-right" />
      </div>
      <div className="space-y-4">
        <div>
          <label className="sf-label">Actual ELM</label>
          <input type="text" inputMode="decimal" maxLength={4} name="operationalEfficiency.extraLaborAndMaterial.actualELM"
            value={data.actualELM} placeholder="Typical values (0.01 - 1.2), max 2.00"
            onFocus={e => e.target.select()} disabled={!isEditable}
            onChange={e => {
              const value = e.target.value;
              if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                const num = parseFloat(value);
                if (value !== '' && !isNaN(num)) { if (num > 0 && num < 0.01) { e.target.value = '0.01'; onInputChange(e, { type: "decimal", maxLength: 4 }); return; } if (num > 2) return; }
                onInputChange(e, { type: "decimal", maxLength: 4 });
              }
            }}
            onBlur={e => {
              const value = e.target.value.trim();
              if (!value || value === '.' || parseFloat(value) === 0) { e.target.value = ''; onInputChange(e, { type: "decimal", maxLength: 4 }); return; }
              const num = parseFloat(value);
              if (!isNaN(num)) { if (num > 0 && num < 0.01) { e.target.value = '0.01'; onInputChange(e, { type: "decimal", maxLength: 4 }); } else if (num > 2) { e.target.value = '2.00'; onInputChange(e, { type: "decimal", maxLength: 4 }); } }
            }}
            className="sf-input mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">Goal</label>
          <input type="text" readOnly name="operationalEfficiency.extraLaborAndMaterial.goal"
            value={data.goal ? parseFloat(data.goal) : ""} className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
        <div>
          <label className="sf-label">% of Revenue</label>
          <input type="text" readOnly name="operationalEfficiency.extraLaborAndMaterial.percentOfRevenue"
            value={data.percentOfRevenue ? (parseFloat(data.percentOfRevenue) * 100).toFixed(0) : ""}
            className="sf-input-ro mt-1 block w-full px-3 py-2 text-right" />
        </div>
      </div>
    </div>
    <p className="sf-hint">70%–120% of Benchmark</p>
    <div className="sf-results grid grid-cols-4 gap-4">
      <div>
        <div className="sf-results-label">Bonus % Earned</div>
        <input type="text" readOnly name="operationalEfficiency.extraLaborAndMaterial.bonusPercentEarned"
          value={data.bonusPercentEarned && !isNaN(parseFloat(data.bonusPercentEarned)) ? Math.round(parseFloat(data.bonusPercentEarned)) : ""}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">{percentOfTotalAchievementScore}%</div>
        <input type="text" readOnly name="operationalEfficiency.extraLaborAndMaterial.bonusValue"
          value={percentOfTotalAchievementScore && !isNaN(percentOfTotalAchievementScore) ? (percentOfTotalAchievementScore * 0.01).toFixed(2) : ""}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
      <div>
        <div className="sf-results-label">Score</div>
        <input type="text" readOnly name="operationalEfficiency.extraLaborAndMaterial.score"
          value={data.score && !isNaN(parseFloat(data.score)) ? parseFloat(data.score).toFixed(0) : ""}
          className="sf-input-ro w-24 px-2 py-1 text-right" />
      </div>
    </div>
  </div>
);

export default ExtraLaborAndMaterialSubForm;